const getters = {
  get_country_by_id: (state) => (country_id) => {
    return country_id === null ? '' : state.countries.find(c => c.id === country_id)
  }
}

export default getters
